import React from 'react';

const Tabs = ({ activeTab, onTabChange, tabs }) => {
  return (
    <div className="tabs-container" style={{
      background: 'var(--bg-secondary)',
      borderRadius: '12px',
      padding: '8px',
      marginBottom: '20px',
      boxShadow: '0 2px 8px var(--shadow-color)'
    }}>
      <div className="tabs-list" style={{
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            style={{
              background: activeTab === tab.id ? 'var(--button-bg)' : 'transparent',
              color: activeTab === tab.id ? 'white' : 'var(--text-primary)',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 20px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              minWidth: 'fit-content',
              flex: '1 1 auto',
              justifyContent: 'center'
            }}
          >
            <span style={{ fontSize: '16px' }}>{tab.icon}</span>
            <span style={{ whiteSpace: 'nowrap' }}>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* CSS للاستجابة */}
      <style jsx>{`
        @media (max-width: 768px) {
          .tabs-container {
            padding: 6px !important;
            marginBottom: 15px !important;
          }
          
          .tabs-list {
            gap: 6px !important;
          }
          
          .tabs-list button {
            padding: 10px 15px !important;
            font-size: 13px !important;
            flex: 1 1 calc(50% - 3px) !important;
            min-width: 0 !important;
          }
          
          .tabs-list button span:first-child {
            font-size: 14px !important;
          }
        }
        
        @media (max-width: 480px) {
          .tabs-container {
            padding: 4px !important;
            marginBottom: 10px !important;
          }
          
          .tabs-list {
            gap: 4px !important;
          }
          
          .tabs-list button {
            padding: 8px 12px !important;
            font-size: 12px !important;
            flex: 1 1 calc(50% - 2px) !important;
          }
          
          .tabs-list button span:first-child {
            font-size: 12px !important;
          }
          
          .tabs-list button span:last-child {
            display: none !important;
          }
        }
        
        @media (max-width: 360px) {
          .tabs-list {
            flex-direction: column !important;
          }
          
          .tabs-list button {
            flex: 1 1 auto !important;
            width: 100% !important;
            margin-bottom: 4px !important;
          }
          
          .tabs-list button span:last-child {
            display: inline !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Tabs; 